// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CuponesGanadoresTelekino_container__XDsJC {
  animation: CuponesGanadoresTelekino_init__Faf4b 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

/*--Header--*/
.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_titleContainer__JvnfH {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_titleContainer__JvnfH h4 {
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_uploadBtn__OSMV0 {
  width: 100%;
  margin-bottom: 10px;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_noResults__yP1Xp {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 300;
  height: 300px;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_filters__BhQTL {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_filters__BhQTL .CuponesGanadoresTelekino_filterButton__jLD6L {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_filters__BhQTL .CuponesGanadoresTelekino_filterButton__jLD6L p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_data__U3Oka .CuponesGanadoresTelekino_tableContainer__Zna1\\+ {
  border-radius: 10px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_data__U3Oka .CuponesGanadoresTelekino_tableContainer__Zna1\\+ .CuponesGanadoresTelekino_iconbtn__hRxGh {
  transition: 0.3s;
  font-size: 2rem;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_data__U3Oka .CuponesGanadoresTelekino_tableContainer__Zna1\\+ .CuponesGanadoresTelekino_iconbtn__hRxGh:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_data__U3Oka .CuponesGanadoresTelekino_pagination__57YVr {
  margin-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_loader__wif6n {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.CuponesGanadoresTelekino_labelUpload__\\+E4hB {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  transition: ease 0.5s;
}

.CuponesGanadoresTelekino_input1__9NerA {
  display: none;
}

@keyframes CuponesGanadoresTelekino_init__Faf4b {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .CuponesGanadoresTelekino_container__XDsJC .CuponesGanadoresTelekino_header__4JWBS .CuponesGanadoresTelekino_titleContainer__JvnfH h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/CuponesGanadores/CuponesGanadoresTelekino.module.css"],"names":[],"mappings":"AAAA;EACE,kDAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .uploadBtn {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  border-radius: 10px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 2rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .data .pagination {\n  margin-top: 50px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.labelUpload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n  transition: ease 0.5s;\n}\n\n.input1 {\n  display: none;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CuponesGanadoresTelekino_container__XDsJC`,
	"init": `CuponesGanadoresTelekino_init__Faf4b`,
	"header": `CuponesGanadoresTelekino_header__4JWBS`,
	"titleContainer": `CuponesGanadoresTelekino_titleContainer__JvnfH`,
	"uploadBtn": `CuponesGanadoresTelekino_uploadBtn__OSMV0`,
	"noResults": `CuponesGanadoresTelekino_noResults__yP1Xp`,
	"filters": `CuponesGanadoresTelekino_filters__BhQTL`,
	"filterButton": `CuponesGanadoresTelekino_filterButton__jLD6L`,
	"data": `CuponesGanadoresTelekino_data__U3Oka`,
	"tableContainer": `CuponesGanadoresTelekino_tableContainer__Zna1+`,
	"iconbtn": `CuponesGanadoresTelekino_iconbtn__hRxGh`,
	"pagination": `CuponesGanadoresTelekino_pagination__57YVr`,
	"loader": `CuponesGanadoresTelekino_loader__wif6n`,
	"labelUpload": `CuponesGanadoresTelekino_labelUpload__+E4hB`,
	"input1": `CuponesGanadoresTelekino_input1__9NerA`
};
export default ___CSS_LOADER_EXPORT___;
